// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__zbsn6","rotation":"LoadingSpinner_rotation__7E-eR"};